import { Button, Tab, Tabs, TextField, ButtonGroup, Tooltip, TableContainer, TableHead, TableRow, Table, TableCell, TableBody } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { getM23ById, approveM23, deleteM23 } from "../../../services/api";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import { useReactToPrint } from "react-to-print";
import { statusColor } from "../../config";
import moment from "moment";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { useTranslation } from "react-i18next";
import { DeleteDialog } from "../../commons/dialog.component";
import TicketForm from "../ticket/ticketPreview";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";

const TicketContext = React.createContext();

export function M23Detail({ id, onSaveResponse, onUpdate, onDelete }) {
  // hook
  const [t] = useTranslation();
  const printRef = useRef();
  const editButtonRef = useRef();
  // state
  const [isAllow, setAllow] = useState(true);
  const [detailData, setDetailData] = useState();
  const [currentTab, setCurrentTab] = useState(0);
  const [inputData, setInputData] = useState({
    note: "",
  });
  const [hidden, setHidden] = useState(true);
  const history = useHistory();
  // const importProcess = ticketData?.m23.process && JSON.parse(ticketData.m23.process)?.IMPORT
  const fetchNewData = () => {
    getM23ById(id).then((res) => {
      if (res.code === 403) {
        setAllow(false);
        return;
      }
      res.code === 200 && setDetailData(res.data);
    });
  };
  const handleSubmit = () => {
    return approveM23(id, inputData);
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const handleDeleteAction = () => {
    return deleteM23(id);
  };
  const handleDeleteResponse = (res) => {
    if (res.code === 200) {
      try {
        let newTicketData = JSON.parse(JSON.stringify(detailData)); // deep clone current ticket data
        newTicketData.receipt.status = "DELETED";
        setDetailData(newTicketData);
        onDelete?.(id);
      } catch (error) {}
    }
  };
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      try {
        let newTicketData = res.data;
        setDetailData(newTicketData);
        onSaveResponse(id);
      } catch (error) {}
    }
  };
  useEffect(() => {
    if (!hidden) {
      printRef.current && handlePrint();
      setHidden(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hidden]);

  useEffect(() => {
    if (!id) return;
    fetchNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useEffect(() => {
    if (detailData)
      setInputData({
        note: detailData.receipt?.remarks || "",
      });
  }, [detailData]);
  if (!isAllow) return t("No permission");
  if (detailData)
    return (
      <TicketContext.Provider value={detailData}>
        <div>
          {Boolean(detailData.forms) && (
            <>
              <div style={{ paddingBottom: 0, display: "flex", position: "relative", justifyContent: "center", alignItems: "center", backgroundColor: "#b3deff" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Tabs value={currentTab} style={{ position: "relative", margin: "auto" }}>
                    <Tab onClick={() => setCurrentTab(0)} label={t("Chi tiết")} />
                    {Object.keys(detailData.forms).map((key) => (
                      <Tab key={key} value={key} onClick={() => setCurrentTab(key)} label={key} />
                    ))}
                  </Tabs>
                </div>
                <div style={{ position: "absolute", right: 0 }}>
                  <ButtonGroup style={{ height: 48 }}>
                    {detailData.receipt?.status === "PUBLISHED" && (
                      <Tooltip title="Phát hành thay thế">
                        <Button variant="outlined" color="primary" onClick={() => history.push({ pathname: `/m23/${detailData.receipt.id}/replace`, state: detailData })}>
                          <RepeatOneIcon />
                        </Button>
                      </Tooltip>
                    )}
                    {detailData.receipt?.status !== "DELETED" && (
                      <Tooltip title="Huỷ">
                        <ButtonWithAPICall variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                          <DeleteIcon />
                        </ButtonWithAPICall>
                      </Tooltip>
                    )}

                    {/* <Tooltip title='Save'> */}
                    {editButtonRef.current}
                    {/* </Tooltip> */}
                    <Tooltip title="In lại">
                      <Button variant="outlined" color="primary" onClick={() => setHidden(false)}>
                        <PrintIcon />
                      </Button>
                    </Tooltip>
                  </ButtonGroup>
                </div>
              </div>
              {Object.keys(detailData.forms).map((key, index) => (
                <div key={index} hidden={currentTab !== key}>
                  <TicketForm
                    isM23={true}
                    ticketData={detailData}
                    onUpdateSuccess={() => fetchNewData()}
                    printRef={currentTab === key ? printRef : null}
                    code={key}
                    ticketid={detailData.receipt.id}
                    data={detailData.forms[key]}
                  />
                </div>
              ))}
            </>
          )}
          <div hidden={currentTab !== 0}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
              <h2 style={{ marginBottom: 0 }}>Phiếu nhập mua hàng nội địa: {detailData.receipt?.fkey}</h2>
              <div className={`status ${detailData.receipt?.status}`} style={{ color: statusColor[detailData.receipt?.status] }}>
                {t(detailData.receipt?.status)}
              </div>
            </div>
            <div align="left" style={{ marginBottom: 5 }}>
              <b>{t("Thông tin hóa đơn nhập mua hàng quốc nội")}</b>:
            </div>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">ERP Code: {detailData?.receipt.erp_code}</TableCell>
                    <TableCell align="left">
                      {t("Số PO")}: {detailData?.receipt.pos_id} ({detailData?.receipt.product_name})
                    </TableCell>
                    <TableCell align="left" colSpan={1}>
                      {t("Nhà cung cấp")}: {detailData?.receipt.provider_name}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Số hóa đơn nhập mua")}: {detailData?.receipt.billNumber}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      {t("Ngày hóa đơn nhập mua")}: {detailData?.receipt.bill_date && moment(detailData.receipt.bill_date).format("DD/MM/YYYY")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Phương tiện")}: {detailData?.receipt.vehicle_name}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      {t("Lái xe")}: {detailData?.receipt.trans_resp}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      {t("Hàng hóa")}: {detailData?.receipt.product_name}
                    </TableCell>
                    <TableCell align="left" colSpan={2}>
                      {t("Chứng chỉ")}: {detailData?.receipt.billCert}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <div>
              <div style={{ margin: "10px 0" }}>
                <div align="left" style={{ marginBottom: 5 }}>
                  <b>{t("Thông tin hàng hóa")}:</b>
                </div>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("STT")}</TableCell>
                        <TableCell>{t("BLL")}</TableCell>
                        <TableCell>VCF</TableCell>
                        <TableCell>WCF</TableCell>
                        <TableCell>{t("Lit")}</TableCell>
                        <TableCell>{t("KG")}</TableCell>
                        <TableCell>L15</TableCell>
                        <TableCell>{t("Nhiệt độ")}</TableCell>
                        <TableCell>D15</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>1</TableCell>
                        <TableCell>{detailData.receipt.billQty?.toLocaleString(undefined, { minimumFractionDigits: 3 }) || ""}</TableCell>
                        <TableCell>{detailData.receipt.billdensity15 && parseFloat(detailData.receipt.billvcf)?.toFixed(4)}</TableCell>
                        <TableCell>{detailData.receipt.billdensity15 && parseFloat(detailData.receipt.billwcf)?.toFixed(4)}</TableCell>
                        <TableCell>{detailData.receipt.billLTT?.toLocaleString() || ""}</TableCell>
                        <TableCell>{detailData.receipt.billKG?.toLocaleString() || ""}</TableCell>
                        <TableCell>{detailData.receipt.billL15?.toLocaleString() || ""}</TableCell>
                        <TableCell>{detailData.receipt.billtemperature && parseFloat(detailData.receipt.billtemperature)?.toFixed(2)}</TableCell>
                        <TableCell>{detailData.receipt.billdensity15 && parseFloat(detailData.receipt.billdensity15)?.toFixed(4)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>

            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>Thông tin kho nhập hàng:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        {t("Chi nhánh")}: {detailData?.receipt.inventory_name}
                      </TableCell>
                      <TableCell align="left" colSpan={2}>
                        {t("Bồn/Bể nhập")}: {detailData?.receipt.tank_name}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div style={{ margin: "10px 0" }}>
              <div align="left" style={{ marginBottom: 5 }}>
                <b>Ghi chú:</b>
              </div>
              <TableContainer>
                <Table>
                  <TableBody>
                    <TableRow>
                      <TextField value={inputData.note} onChange={(e) => setInputData((prev) => ({ ...prev, note: e.target.value }))} />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <ButtonWithAPICallComponent api={handleSubmit} response={handleSaveResponse} variant="contained">
              {t("Lưu")}
            </ButtonWithAPICallComponent>
          </div>
          {/* <div hidden={hidden} ref={currentTab === 0 ? printRef : null}><TicketPreview data={ticketData} /></div> */}
        </div>
      </TicketContext.Provider>
    );
  return "";
}
